import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import baseUrl from 'shared/util/baseUrl';
import './RiskStatus.scss';
import { connect } from 'react-redux';

/**
 * a helper function to convert string into one word by replacing space with underscore then make it lowercase
 * @param {*} string
 */

const RiskStatus = ({ summary, intl }) => (
  <div className="risk-status">
    <img src={`${baseUrl}/images/risk-${summary['summary.risk']}.svg`} alt={summary['summary.risk']} />
    <FormattedMessage id="risk.youAre" values={{ risk: summary['summary.risk'] && <b>{intl.formatMessage({ id: summary['summary.risk'] })}</b> }} />
  </div>
);

const mapStateToProps = state => ({
  summary: state.rootReducer.summary,
});


export default connect(mapStateToProps)(injectIntl(RiskStatus));
